module.exports = __webpack_public_path__ + "static/5-3437a85926331ce0cb101649ddd2cd6a.jpg";